import { EnterpriseCustomerService } from './../../services/enterprise-customer.service';
import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EventV2Dto } from 'src/app/api/exa';

@Component({
  selector: 'app-customer-select-dialog',
  templateUrl: './customer-select-dialog.component.html',
  styleUrls: ['./customer-select-dialog.component.scss'],
})
export class CustomerSelectDialogComponent implements OnInit {
  @Input() username;
  @Input() latitude;
  @Input() longitude;
  @Input() machineId;
  @Input() owner;
  @Input() type;

  customerList = null;
  selectedCustomer = null;
  selectedCustomerId = null;

  time = new Date().getTime();

  constructor(
    public modalCtrl: ModalController,
    private customerService: EnterpriseCustomerService
  ) {
    this.customerService.onGetEnterpriseCustomers(true).subscribe((customers) => {
      console.log(customers);
      this.customerList = [...customers];
    });
  }

  ngOnInit() {}

  dismiss() {
    this.modalCtrl.dismiss({
      selectedCustomer: this.selectedCustomer,
    });
  }

  onClickCancel() {
    this.dismiss();
  }

  onSelectCustomer(ev) {
    this.selectedCustomerId = ev.detail.value;
    this.selectedCustomer = this.customerService.getCustomerById(ev.detail.value);
  }

  onClickChoose() {
    const selectCustomer: EventV2Dto = {
      data: this.selectedCustomerId,
      employee: this.username,
      latitude: this.latitude,
      longitude: this.longitude,
      machine: this.machineId,
      owner: this.owner,
      time: this.time.toString(),
      type: this.type,
    };
    //poner el evento cuando tenga acceso al backend
    console.log(selectCustomer);
    this.dismiss();
  }
}
